import {ViewTypeVo} from '../../common/shared/api/karina/vo/enums/ViewTypeVo.enum';
import {GroupType, SectionType} from '../generated/types';

export function createGroupType(
  viewTypeVo: ViewTypeVo,
  sectionType: SectionType
): GroupType {
  return groupMap[viewTypeVo]?.(sectionType) || GroupType.Unknown;
}

const groupMap: {
  [key in ViewTypeVo]: (sectionType: SectionType) => GroupType;
} = {
  [ViewTypeVo.SeriesCardView]: sectionType =>
    sectionType === SectionType.ScrollTheme
      ? GroupType.HorizontalScroll
      : GroupType.CardView,
  [ViewTypeVo.SingleCardView]: sectionType =>
    sectionType === SectionType.ScrollTheme
      ? GroupType.HorizontalScroll
      : GroupType.CardView,
  [ViewTypeVo.SeriesPosterView]: sectionType =>
    sectionType === SectionType.RecentViewed
      ? GroupType.HorizontalScroll
      : GroupType.PosterView,
  [ViewTypeVo.SinglePosterView]: () => GroupType.PosterView,
  [ViewTypeVo.SeriesListView]: sectionType =>
    sectionType === SectionType.MainRanking
      ? GroupType.MainRankingListView
      : GroupType.ListView,
  [ViewTypeVo.SingleListView]: () => GroupType.ListView,
  [ViewTypeVo.SeriesCleanView]: () => GroupType.CleanView,
  [ViewTypeVo.SingleCleanView]: () => GroupType.CleanView,
  [ViewTypeVo.RectangleView]: getBannerGroup,
  [ViewTypeVo.SquareView]: getBannerGroup,
  [ViewTypeVo.StrategyView]: () => GroupType.StrategyView,
  [ViewTypeVo.BannerCardView]: () => GroupType.CardView,
  [ViewTypeVo.BannerPromotionView]: () => GroupType.PromotionBanner,
  [ViewTypeVo.BannerLineView]: () => GroupType.LineBanner,
};

function getBannerGroup(sectionType: SectionType) {
  return sectionType === SectionType.Event
    ? GroupType.EventBanner
    : sectionType === SectionType.Theme
      ? GroupType.StandaloneBanner
      : sectionType === SectionType.BigBanner
        ? GroupType.ResponsiveBanner
        : GroupType.BigBanner; // TOP
}
